import { SuccessResponse } from 'ts/types/ApiResponse'

type Props = {
  success: SuccessResponse | null
}

const Success = ({ success }: Props) =>
  success ? (
    <div className="self-end w-full px-10 py-6 mb-4 text-sm text-white bg-green-500 rounded shadow-xl">
      <h2 className="font-bold">{success.title}</h2>
      {success.message}
    </div>
  ) : null

export default Success
